var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 144,
    viewBox: "0 0 204 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.549 34.2625H80.5488V109.738H122.549V34.2625Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2156 72C83.209 64.7313 84.8561 57.5562 88.0324 51.0181C91.2086 44.48 95.8307 38.7502 101.549 34.2625C94.4678 28.6967 85.9637 25.2354 77.0086 24.2743C68.0534 23.3131 59.0085 24.8908 50.9077 28.8272C42.8069 32.7635 35.9769 38.8996 31.1986 46.5341C26.4202 54.1686 23.8862 62.9935 23.8862 72C23.8862 81.0066 26.4202 89.8315 31.1986 97.466C35.9769 105.1 42.8069 111.237 50.9077 115.173C59.0085 119.109 68.0534 120.687 77.0086 119.726C85.9637 118.765 94.4678 115.303 101.549 109.738C95.8307 105.25 91.2087 99.52 88.0324 92.9819C84.8562 86.4438 83.209 79.2688 83.2156 72Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.209 72C179.209 81.0065 176.676 89.8313 171.897 97.4658C167.119 105.1 160.29 111.236 152.189 115.173C144.088 119.109 135.044 120.687 126.089 119.726C117.134 118.765 108.63 115.303 101.549 109.738C107.262 105.245 111.88 99.5146 115.056 92.9775C118.232 86.4405 119.882 79.2677 119.882 72C119.882 64.7324 118.232 57.5596 115.056 51.0225C111.88 44.4855 107.262 38.7548 101.549 34.2625C108.63 28.6967 117.134 25.2354 126.089 24.2743C135.044 23.3131 144.088 24.8909 152.189 28.8273C160.29 32.7636 167.119 38.8998 171.897 46.5343C176.676 54.1688 179.209 62.9936 179.209 72Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.629 101.744V100.198H175.252V99.8835H173.666V100.198H174.289V101.744H174.629ZM177.71 101.744V99.8805H177.224L176.664 101.162L176.104 99.8805H175.618V101.744H175.961V100.338L176.486 101.55H176.842L177.367 100.335V101.744H177.71Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.57be1d9bdd94edeef1344da8ccc80f8a.svg";
export { ForwardRef as ReactComponent };